import type { ReactNode } from 'react'
import Box from '@mui/material/Box'
import { surveyEntryCardInnerSx, surveyEntryCardSx } from '../styles/surveyEntryStyles'
import { SurveyEntryLogo } from './SurveyEntryLogo'

interface SurveyEntryCardProps {
  readonly children: ReactNode
}

export function SurveyEntryCard({ children }: SurveyEntryCardProps) {
  return (
    <Box data-testid="survey-entry-card" sx={surveyEntryCardSx}>
      <Box sx={surveyEntryCardInnerSx}>
        <SurveyEntryLogo />
        {children}
      </Box>
    </Box>
  )
}
